export default "__VITE_ASSET__DMn2nO5V__"